'use strict';

var novicell = novicell || {};

novicell.button = novicell.button || new function () {
    this.init = function () {
        var ghostButtons = document.querySelectorAll('.grid-section__column--has-theme .button--ghost, .rte--has-theme .button--ghost, .grid-section--has-theme .button--ghost');

        for (let i = 0; i < ghostButtons.length; i++) {
            const currentButton = ghostButtons[i];
            var bgColor = getComputedStyle(currentButton).backgroundColor;
            var textColor = getComputedStyle(currentButton).color;
            var linkInside = currentButton.querySelector('a');

            if (linkInside) {
                linkInside.style.backgroundColor = 'transparent';
                linkInside.style.color = bgColor;
            }

            currentButton.style.borderColor = bgColor;
            currentButton.style.backgroundColor = 'transparent';
            currentButton.style.color = bgColor;
        }
    };
}();
